var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[(_vm.dados)?_c('div',{staticClass:"header-info"},[_c('h1',[_vm._v(_vm._s(_vm.dados.nome))]),_c('span',[_c('p',[_vm._v(_vm._s(_vm.dados.uh))]),_c('p',[_vm._v(_vm._s(`Reserva: ${_vm.dados.numeroreserva}`))])])]):_vm._e(),_c('div',{staticClass:"grow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }